import { BasicTrackingCommand } from "./BasicTrackingCommand";
/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 20.09.13
 * Time: 18:19
 * To change this template use File | Settings | File Templates.
 */


export class BasicFirstSessionTrackingCommand extends BasicTrackingCommand {
    public get commandIsAllowed(): boolean {
        return this.env.doUserTunnelTracking && !this.env.isLocal;
    }
}

